import React, {Component} from 'react'
import {connect} from 'react-redux'
import {NavBar, NavBarItem, Badge} from 'react-weui'
import { browserHistory } from 'react-router'
import '../../styles/components/WKTab.css'


class WKTab extends Component {
    constructor() {
        super()
        this.handleSelectTab = this.handleSelectTab.bind(this)
    }
    componentDidMount () {
        this.props.dispatch({
            type: 'COMPONENT_INIT_WKTAB',
            payload: {
                selectId: 1,
                list: [{
                    id: 1,
                    name: '我的消息',
                }, {
                    id: 2,
                    name: '系统消息',
                }]
            }
        })
        this.props.dispatch({
            type: 'COMPONENT_SELECT_TAB',
            payload: this.props.routeTab === 'my' ? 1 : 2
        })
    }
    handleSelectTab(id) {
        this.props.dispatch({
            type: 'COMPONENT_SELECT_TAB',
            payload: id
        })
        browserHistory.replace(`/message/${+id === 1 ? 'my' : 'system' }`)
    }
    getUnreadAmount (list) {
        if (!list) return 0
        let amount = 0
        list.forEach(item => {
            amount += +item.unread
        })
        return amount
    }
    render() {
        const {wkTabList} = this.props
        const unreadAmount = this.getUnreadAmount(this.props.myMsgs)
        return (
            <div className="tab-wrap">
                <div className="wk-tab">
                    <NavBar className="wk-tab-navbar">
                        {wkTabList.map((item, index) => (
                            <NavBarItem data-id={item.id} key={item.id} className="wk-tab-navbar-item"
                                        active={item.selected} onClick={() => this.handleSelectTab(item.id)}>
                                <span className='text'>{item.name}
                                    { (index === 1 && unreadAmount > 0) && <Badge preset='footer'>{unreadAmount}</Badge> }
                                </span>
                            </NavBarItem>
                        ))}
                    </NavBar>
                </div>
            </div>
        )
    }
}


export default connect((state) => ({
    wkTabList: state.component.wkTab.list
}))(WKTab)


// WEBPACK FOOTER //
// ./src/components/message/Tab.js